export default "__VITE_ASSET__BnpMExkX__"